import { Box, Button, Checkbox, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import Sidebar from "../sidebar";
import CompanyDetails from "./CompanyDetails";
import Wellbeing from "./Social/Wellbeing";
import HumanRights from "./Social/HumanRights";
import Diversity from "./Social/Diversity";
import Community from "./Social/Community";
import CustomerRelation from "./Social/CustomerRelation";
import Environment from "./Environment";
import SupplyChain from "./Social/SupplyChain";
import Governance from "./Governance";
import EastIcon from "@mui/icons-material/East";
import ESGBaselineYear from "./ESGBaselineYear";
import { useNavigate } from "react-router-dom";
import style from "./download.css";
import html2pdf from "html2pdf.js";
import { api, post } from "../../../utils/api";
import { formatTimestamp } from "../../../utils/formatTimeStamp";
import axios from "axios";
import MessagePopup from "../../Masters/MessagePopup";
import { ProgressContext } from "../ContextAPI";
import { downloadReport } from "./downloadReport";
import { generatePdf } from "./generatePdf";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";

const PageBreak = () => <div className="page-break" />;

const PreviewDetails = () => {
  const [checked, setChecked] = useState(false);
  const [isEditing, setIsEditing] = useState(true);
  const reportRef = useRef();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const { setUpdate } = useContext(ProgressContext);

  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  const navigate = useNavigate();

  // const generatePdfBlob = async () => {
  //   const element = reportRef.current;
  //   const opt = {
  //     margin: 10,
  //     filename: "Initial_Questionnaire.pdf",
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: {
  //       scale: 2,
  //       useCORS: true,
  //       logging: true,
  //     },
  //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //     pagebreak: { mode: ["avoid-all", "css", "legacy"] },

  //     // Add this configuration for page numbers
  //     onclone: (clonedDoc) => {
  //       // This function runs after the document is cloned but before conversion
  //       const pages = clonedDoc.querySelectorAll('.html2pdf__page-break');
  //       const totalPages = pages.length + 1; // +1 for the first page

  //       // Add page number container to each page
  //       pages.forEach((page, index) => {
  //         const pageNumberDiv = document.createElement('div');
  //         pageNumberDiv.style.position = 'absolute';
  //         pageNumberDiv.style.bottom = '10px';
  //         pageNumberDiv.style.width = '100%';
  //         pageNumberDiv.style.textAlign = 'center';
  //         pageNumberDiv.style.fontSize = '12px';
  //         pageNumberDiv.style.color = '#666';
  //         pageNumberDiv.textContent = `Page ${index + 1} of ${totalPages}`;

  //         page.appendChild(pageNumberDiv);
  //       });

  //       // Add page number to the first page
  //       const firstPageNumberDiv = document.createElement('div');
  //       firstPageNumberDiv.style.position = 'absolute';
  //       firstPageNumberDiv.style.bottom = '10px';
  //       firstPageNumberDiv.style.width = '100%';
  //       firstPageNumberDiv.style.textAlign = 'center';
  //       firstPageNumberDiv.style.fontSize = '12px';
  //       firstPageNumberDiv.style.color = '#666';
  //       firstPageNumberDiv.textContent = `Page 1 of ${totalPages}`;

  //       clonedDoc.body.insertBefore(firstPageNumberDiv, clonedDoc.body.firstChild);
  //     }
  //   };

  //   try {
  //     // Generate PDF as blob
  //     const pdfBlob = await html2pdf().set(opt).from(element).outputPdf("blob");

  //     if (!pdfBlob || pdfBlob.size === 0) {
  //       throw new Error("Generated PDF blob is empty");
  //     }

  //     return pdfBlob;
  //   } catch (err) {
  //     console.error("PDF generation failed:", err);
  //     throw err;
  //   }
  // };

  const uploadPdfToServer = async (pdfBlob) => {
    const formData = new FormData();
    const timestamp = Date.now();

    const formattedTimestamp = formatTimestamp(timestamp);

    const uniqueFile = new File(
      [pdfBlob],
      `Initial_Questionnaire__${formattedTimestamp}.pdf`,
      { type: pdfBlob.type },
    );

    formData.append("files", uniqueFile);

    try {
      const response = await axios.post(`${api}/cloud/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response?.data?.urls?.[0];
    } catch (err) {
      console.error("Upload failed:", err);
      throw err;
    }
  };

  const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  };

  const handleSubmit = () => {
    if (!checked || isGeneratingPdf) return;

    setIsGeneratingPdf(true);
    setIsEditing(false);

    // Use a timeout to ensure DOM is fully painted before PDF generation
    setTimeout(async () => {
      try {
        // 1. Generate PDF blob from the reportRef content
        const pdfBlob = await generatePdf(reportRef);

        if (!pdfBlob || pdfBlob.size === 0) {
          throw new Error("PDF generation failed: Created blob is empty.");
        }

        // 2. Upload the blob to your server to get a URL
        const url = await uploadPdfToServer(pdfBlob);

        // 3. Submit that URL to your API
        await post("api/preview/submit", { url });

        // 4. Trigger a download of the same blob for the user
        downloadBlob(pdfBlob, "Initial_Questionnaire.pdf");

        // 5. Show success feedback and navigate away
        setsnackOpen({
          open: true,
          message:
            "Questionnaire submitted successfully. Your report is downloading.",
          severity: "success",
        });

        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
      } catch (err) {
        console.error("Error during the PDF submission process:", err);
        setsnackOpen({
          open: true,
          message: `Submission failed: ${err.message || "Please try again."}`,
          severity: "error",
        });
      } finally {
        // 6. Reset the state regardless of success or failure
        setIsGeneratingPdf(false);
        setIsEditing(true); // Allow user to make changes if submission failed
      }
    }, 100); // A small delay is crucial for the browser to paint updates
  };

  return (
    <Box sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>
      <Box
        sx={{
          p: 2,
          width: "75vw",
          mt: "2rem",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            mb: "1.5rem",
          }}
        >
          <Typography
            sx={{
              fontSize: "28px",
              fontWeight: 600,
              fontStyle: "inter",
              textTransform: "uppercase",
            }}
          >
            Preview Details
          </Typography>
        </Box>
        <div ref={reportRef} className={style.page_break}>
          <CompanyDetails isEditing={isEditing} />
          <PageBreak />
          <ESGBaselineYear isEditing={isEditing} />
          <PageBreak />
          <Environment isEditing={isEditing} />
          <PageBreak />
          <Wellbeing isEditing={isEditing} />
          <Diversity isEditing={isEditing} />
          <PageBreak />
          <Community isEditing={isEditing} />
          <HumanRights isEditing={isEditing} />
          <CustomerRelation isEditing />
          <PageBreak />
          <CustomerRelation isEditing={isEditing} />
          <SupplyChain isEditing={isEditing} />
          <PageBreak />
          <Governance isEditing={isEditing} />
        </div>
        <Box>
          <Box
            sx={{
              background: "#1C486B",
              my: "2rem",
              p: 3,
              borderRadius: "10px",
              //   width: "36%",
            }}
          >
            {" "}
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                fontStyle: "inter",
                textTransform: "uppercase",
                color: "#ffffff",
              }}
            >
              review & submit answers
            </Typography>
            <Box
              display="flex"
              // alignItems="center"
              gap={1}
              sx={{ color: "white", ml: "-0.5rem", mt: "1rem" }} // Applies white to text
            >
              <Box>
                <Checkbox
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "inter",
                  color: "#ffffff",
                  mt: "0.5rem",
                  lineHeight: "24px",
                }}
              >
                By clicking "I Accept," you confirm that the information
                provided in this questionnaire is accurate and complete to the
                best of your knowledge.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                onClick={handleSubmit}
                disabled={!checked || isGeneratingPdf}
                sx={{
                  backgroundColor: "#1C486B",
                  textTransform: "none",
                  background: "#fff",
                  color: "#000000",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "5px",
                  border: "none",
                  px: "1rem",
                  width: "12rem",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#f5f5f5", // keep white background on hover
                  },
                }}
              >
                {isGeneratingPdf ? (
                  "Submitting..."
                ) : (
                  <span>
                    Save & Submit <EastIcon sx={{ ml: 2 }} />
                  </span>
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PreviewDetails;
